<template>
    <router-link
        active-class="text-white bg-gray-700"
        class="group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-200 rounded-md | hover:text-white hover:bg-gray-700 | focus:outline-none focus:text-white focus:bg-gray-700 | transition ease-in-out duration-150"
        :exact="false"
        tag="a"
        :to="{ name: view }"
    >
        <svg
            class="mr-4 h-6 w-6 text-gray-200 group-hover:text-gray-200 group-focus:text-gray-200 transition ease-in-out duration-150"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
            />
        </svg>
        {{ text }}
    </router-link>
</template>

<script>
    export default {
        props: {
            text: {
                type: String,
                required: true,
            },
            view: {
                type: String,
                required: true,
            },
        },
    };
</script>
